import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NationalStockAllPage } from "./national-stock-all.page";

const routes: Routes = [
  {
    path: "",
    component: NationalStockAllPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NationalStockAllPageRoutingModule {}
